import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function Header() {
  const name = localStorage.getItem("name");
  const image = localStorage.getItem("image");
  const ThanaName = localStorage.getItem("policeStation");
  const circleName = localStorage.getItem("circleName");

  const roleLabelMap = {
    Admin: "Nodal Officer",
    User: "P.S. Head",
    CO: "Circle Head",
    "District Officer": "District Officer",
  };
  const userRole = localStorage.getItem("userRole");
  const district = localStorage.getItem("district");

  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const body = document.body;
    const applyLayout = () => {
      body.classList.remove('nav-md', 'nav-sm');
      body.classList.add(window.innerWidth < 992 ? 'nav-sm' : 'nav-md');
      setIsCollapsed(body.classList.contains('nav-sm'));
    };
    applyLayout();
    window.addEventListener('resize', applyLayout);
    return () => window.removeEventListener('resize', applyLayout);
  }, []);

  const handleToggleSidebar = () => {
    const body = document.body;
    if (body.classList.contains('nav-sm')) {
      body.classList.remove('nav-sm');
      body.classList.add('nav-md');
      setIsCollapsed(false);
    } else {
      body.classList.remove('nav-md');
      body.classList.add('nav-sm');
      setIsCollapsed(true);
    }
  };

  const logOut = () => {
    localStorage.clear();
    window.location.reload();
  }
  return (
    <>
      <div
        className="top_nav"
        style={isCollapsed ? { width: 'calc(100% - 100px)', marginLeft: '100px' } : undefined}
      >
        <div className="nav_menu">
          <nav>
            <div className="nav toggle">
              <button
                type="button"
                id="menu_toggle"
                className="header-menu-toggle"
                aria-label="Toggle sidebar"
                onClick={handleToggleSidebar}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '36px',
                  height: '36px',
                  marginRight: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  background: '#fff',
                  color: '#223973',
                  cursor: 'pointer'
                }}
              >
                <i className="fa fa-bars" />
              </button>
              <div className="header-welcome">
                <h3 className="header-welcome-title">Welcome, {roleLabelMap[userRole] || userRole}{district ? `, ${district}` : ''}.</h3>
                <p className="header-welcome-sub">Here is what's happening with your app today.</p>
              </div>
            </div>
            <ul className="nav navbar-nav navbar-right">
              <li>
                <span className="header-badge">Uttarakhand Police</span>
              </li>
              <li>
                <a href="#" className="header-logout" data-bs-toggle="modal" data-bs-target="#confirmationModel">
                  <i className="fa fa-sign-out" />
                  <span>Logout</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div
        className="modal fade support-modal"
        id="supportModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {/* <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Support</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div className="modal-body px-5 pb-0">
        <div className="row align-items-center">
          <div className="col-md-5">
            <img src="img/support-img.svg" alt="" />
          </div>
          <div className="col-md-7">
            <ul className="list-unstyled">
              <li>
                <span>
                  <i className="fa fa-phone" />
                </span>
                <a href="tel:+91 9057801818">+91 9057801818</a>
              </li>
              <li>
                <span>
                  <i className="fa fa-envelope" />
                </span>
                <a href="mailto:info@truevalueinfosoft.com">
                  info@truevalueinfosoft.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div> */}
      </div>


      <div
        className="modal fade"
        id="confirmationModel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content logout-modal-content">
            <div className="logout-modal-body">
              <div className="logout-modal-icon">
                <i className="fa fa-sign-out" />
              </div>
              <h4 className="logout-modal-title">Log Out</h4>
              <p className="logout-modal-desc">Are you sure you want to log out of your account?</p>
              <div className="logout-modal-actions">
                <button className="logout-modal-cancel"
                  data-bs-dismiss="modal"
                  aria-label="Close">Cancel</button>
                <button className="logout-modal-confirm" onClick={logOut}>Log Out</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>



  )
}

export default Header
